import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { Icon, ClickedOutside } from "./";
import { colours, customFonts, layoutSizes } from "../../constants/css";
var ListWrapper = styled.div.withConfig({
  displayName: "Dropdown__ListWrapper",
  componentId: "sc-1gkgb5t-0"
})(["display:inline-block;position:relative;width:inherit;height:45px;"]);
var List = styled.ul.withConfig({
  displayName: "Dropdown__List",
  componentId: "sc-1gkgb5t-1"
})(["display:table;position:absolute;list-style:none;margin:0;padding:0;z-index:1;width:inherit;"]);
var ListItem = styled.li.withConfig({
  displayName: "Dropdown__ListItem",
  componentId: "sc-1gkgb5t-2"
})(["position:relative;height:45px;cursor:pointer;font-family:", ";padding:12.5px;color:", ";border:2px solid ", ";background:", ";line-height:1;i{position:absolute;top:50%;right:0.5rem;transform:translateY(-50%);}&:first-child{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;padding-right:30px;}@media only screen and (min-width:", ") and (max-width:991px){&:first-child{width:inherit;}}@media only screen and (min-width:992px){&:first-child{width:inherit;}}&:not(:first-child){white-space:nowrap;}&:not(:last-child){border-bottom:none;}"], customFonts.ciutadellaMed, colours.qantasCharcoal, colours.qantasLightGrey, function (props) {
  return props.isSelected ? colours.qantasAqua : colours.qantasWhite;
}, layoutSizes.desktopWidth);
var Dropdown = /*#__PURE__*/function (_Component) {
  function Dropdown(props) {
    var _this;
    _classCallCheck(this, Dropdown);
    _this = _callSuper(this, Dropdown, [props]);
    _this.openDropdown = function () {
      if (_this.state.isOpen) {
        return;
      }
      _this.setState({
        isOpen: true
      });
    };
    _this.closeDropdown = function () {
      _this.setState({
        isOpen: false
      });
    };
    _this.selectItem = function (itemIndex) {
      var _this$props = _this.props,
        onSelect = _this$props.onSelect,
        items = _this$props.items;
      _this.setState({
        selectedIndex: itemIndex,
        isOpen: false
      });
      onSelect(items[itemIndex].value);
    };
    _this.handleKeyPress = function (e) {
      // Toggle dropdown when enter is pressed
      if (e.key === 'Enter' || e.which === 13 || e.keyCode === 13) {
        _this.state.isOpen ? _this.closeDropdown() : _this.openDropdown();
      }
    };
    _this.state = {
      selectedIndex: _this.props.defaultIndex,
      isOpen: false
    };
    return _this;
  }
  _inherits(Dropdown, _Component);
  return _createClass(Dropdown, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var nextIndex = nextProps.defaultIndex;
      var currentIndex = this.props.defaultIndex;
      if (nextIndex === currentIndex) {
        return;
      }
      this.setState({
        selectedIndex: nextIndex
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        isOpen = _this$state.isOpen,
        selectedIndex = _this$state.selectedIndex;
      var items = this.props.items;
      if (!(items && items.length > 0)) {
        return null;
      }
      var selectedItem = items[selectedIndex];
      return __jsx(ListWrapper, null, __jsx(ClickedOutside, {
        handleClickOutside: this.closeDropdown
      }, __jsx(List, {
        onKeyPress: this.handleKeyPress,
        onClick: this.openDropdown,
        isOpen: isOpen,
        tabIndex: 0
      }, __jsx(ListItem, {
        onClick: this.closeDropdown,
        tabIndex: 0
      }, selectedItem && selectedItem.name, __jsx(Icon, {
        iconType: isOpen ? 'caretUp' : 'caretDown',
        size: "xxs"
      })), isOpen && items.map(function (item, i) {
        return __jsx(ListItem, {
          key: item.value,
          onClick: function onClick() {
            return _this2.selectItem(i);
          },
          isSelected: item.value === selectedItem ? selectedItem.value : null,
          tabIndex: 0
        }, item.name);
      }))));
    }
  }]);
}(Component);
Dropdown.defaultProps = {
  defaultIndex: 0
};
export default Dropdown;